<template>
  <div class="tabData">
    <div class="right-shopList">
      <div class="rightList-head">
        <div class="commodity" >商品</div>
        <div class="price">售價(元)</div>
        <div class="num" >數量</div>
        <!--<div class="num" >评论</div>-->
        <div class="total">總計(元)</div>
        <div class="order_status">訂單狀態</div>
        <div class="operation">操作</div>
      </div>
      <ul>
        <li v-for="(item , index) in orders" :key="item.id">
          <h4>
            <img  src="../../../assets/icon/address-icon.png" alt="">
            <span >離境倉</span>
            <span >訂單號：{{item.order_sn}}</span>
            <span >下單時間：{{item.created_at}}</span>
          </h4>
          <dl class="right-shopbox shopList-box">
            <div class="shopInformation">
              <dd v-for="goodsList in item.goods.data" :key="goodsList.id">
                <div class="shop-img" @click="goDetails(item)">
                  <a class="shop-imgA">
                    <img :src="goodsList.goods_thumb" alt="極草·5X冬蟲夏草純粉片（經典含片）0.25克/片×60片/瓶">
                    <p>{{goodsList.goods_name}}</p>
                  </a>
                </div>
                <div class="price">
                  <div class="cen"> ￥{{goodsList.goods_price}}</div>
                </div>
                <div class="num">
                  <div class="cen">{{goodsList.goods_number}}</div>
                </div>
              </dd>
            </div>
            <dd class="zongji-money">
              <div class="cen">
                ￥{{item.payment_amount}}元
              </div>
            </dd>
            <dd class="zhuangtai-shop" >
              <div class="cen">
                <span class="zhifuzhuangtai" v-if="item.pay_status == 0 && item.order_status == 0">待付款</span>
                <span class="zhifuzhuangtai" v-else-if="item.pay_status == 0 && item.order_status == -1">已取消</span>
                <span class="zhifuzhuangtai" v-else-if="item.pay_status == 0 && item.order_status == -2">已失效</span>
                <span class="zhifuzhuangtai" v-else-if="item.pay_status == 1 && item.deliver_status == 0 || item.deliver_status == 1">待發貨</span>
                <span class="zhifuzhuangtai" v-else-if="item.pay_status == 1 && item.order_status == 1">待收貨</span>
                <span class="zhifuzhuangtai" v-else-if="item.pay_status == 1 && item.order_status == 2 &&　item.deliver_status　== 2">簽收成功</span>
                <a @click="getIntoDetails(item)">訂單詳情</a>
              </div>
            </dd>
            <dd class="option">
              <div class="cen">
                <a class="btn" v-if="item.pay_status == 0 && item.order_status == 0" @click='goToPay(item)'>立即付款</a>
                <a class="btn" v-else-if="item.pay_status == 1 && item.order_status == 1 && item.deliver_status == 2" @click="conReceipt(item)">確認收貨</a>
                <!--<a class="btn" v-else-if="item.pay_status == 1 && item.order_status == 4" @click="goComment(item)">去評論</a>-->
                <!--<a class="btn" v-else @click="goDetails(item)">再次購買</a>-->
                <a class="btn" v-if="item.pay_status == 1 && item.order_status == 2 && item.deliver_status == 2" @click="goDetails(item)">再次購買</a>
                <a class="cancel" v-if="item.pay_status == 0 && item.order_status == 0" @click="cancelOrder(item)">取消訂單</a>
                <a class="cancel" v-else-if="item.pay_status == 1 && item.order_status == 1 && item.deliver_status == 2" @click="trackingLogistics(item)">物流跟蹤</a>
                <a class="cancel"  v-else-if="item.pay_status == 1 && item.order_status == 2 && item.deliver_status == 2" @click="goComment(item)">去評論</a>
                <a class="cancel print"  v-if="item.pay_status == 1 && item.order_status == 2 && item.deliver_status == 2">打印发票</a>
              </div>
            </dd>
          </dl>
        </li>
      </ul>

      <!--分页-->
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize">
      </el-pagination>

    </div>

    <!--评价弹框-->

    <el-dialog title="商品評論" :visible.sync="dialogFormVisible" :lockScroll="false">
      <el-form :label-width="formLabelWidth" >
        <el-form-item label="評論商品" required>
          <el-row>
            <div style="width: 120px;height: 200px;  margin: 10px;"
                 v-for="(item, index) in commentList"
                 :key="item.id"
                 @click="getOrderId(item)"
                 >
              <el-col :span="6" :class="{on:currentIndex == item.order_goods_id}" >
                <el-card :body-style="{ padding: '0px' }" >
                  <img class="image" :src="item.goods_thumb">
                  <div>
                    <span>{{item.goods_name}}</span>
                  </div>
                </el-card>
              </el-col>
            </div>
             </el-row>
        </el-form-item>
        <el-form-item label="評論等級" required>
          <el-rate v-model="star" show-text>
          </el-rate>
        </el-form-item>
        <el-form-item label="評論內容" required>
          <el-input type="textarea" v-model="comment_reply_desc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="subComment">提交評論</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  //api
  import {updateOrder } from '@/api/order';
  import {releaseComments} from '@/api/comment';
  import {authentication , authenticationMsg} from '@/api/authentication';
  import {getToken} from '@/utils/auts';
    //common.js
  import {getLocalStorage,setLocalStorage , ifSignIn} from '@/utils/common';
  export default {
    name: 'TabData',
    props:['orders','total' ,'pageSize'],
    data () {
      return {
        currentIndex: null,
        //评论弹框
        dialogTableVisible: false,
        dialogFormVisible: false,
        formLabelWidth: '120px',
        //评价内容
        content:{
          user:'',//用户id
          goods:'',//商品id
         },
        star:0,//评论星级
        comment_reply_desc:'',//评论内容
        commentList:[],//需要评论的商品

      }
    },
    methods:{
    /*点击进入订单详情页面*/
      getIntoDetails(item){
          sessionStorage.setItem('detailList',JSON.stringify(item))
          this.$router.push({
            name:'OrderDetails',
            query: {
              orderId: item.id
             }
          })
      },

      /*取消订单*/
      cancelOrder(item){
        updateOrder({order_status:-1},item.id).then(res=>{
          this.$message.success('取消訂單成功');
          this.$emit('allList');
        })
      },

      /*确认收货*/
      conReceipt(item){
        updateOrder({order_status:2},item.id).then(res=>{
          this.$message.success('確認收貨成功');
          this.$emit('allList');
        })
      },

      /*去评论*/
      goComment(item){
        this.dialogFormVisible = true;
        this.content.goods = item.id;
        this.commentList = item.goods.data;
        this.currentIndex=(item.goods.data)[0].order_goods_id;
      },
      /*选择需要评论的商品*/
      getOrderId(item){
          this.currentIndex=item.order_goods_id;
      },

      /*提交评论*/
      subComment(){
        if(this.currentIndex == null){
          this.$message.error('選擇需要評論的商品');
        } else if(this.star == 0){
          this.$message.error('請選擇評論等級');
        }else if(this.comment_reply_desc == ''){
          this.$message.error('請填寫評論內容');
        } else {
            var comList = {
              orderGoods:this.currentIndex,
              star:this.star,
              comment_reply_desc:this.comment_reply_desc
            };
              releaseComments(comList,this.currentIndex).then(res=>{
                this.$message.success('評論提交成功');
                this.dialogFormVisible = false;
            })
        }
      },

      // 立即付款
      goToPay(item){
        //如果订单过期不能支付
        if (item.created_at.substr(0,10) !== this.getData()){
          this.$message.error('該訂單已過期不能支付，請重新下單！');
          return false
        }
        ifSignIn(this, () =>{
      /*    getLocalStorage('orderMsg' ,res=>{
            var orderMsg = res;
            orderMsg.id = item.id;
            setLocalStorage('orderMsg',orderMsg);
          })*/
          var orderMsg = {
            payment_method:JSON.parse(sessionStorage.getItem('orderMsg')),
            id:item.id
          }
          setLocalStorage('orderMsg',orderMsg);
          this.$router.push({name:'OrderPayment',query:{id:item.id}})
        })
      },

    /*点击进去商品详情页*/
    goDetails(item){
        this.$router.push({
          name:'ShopDetails',
          query:{
              id:item.goods.data[0].goods_id
          }
        })
    },

      /*跟踪物流*/
      trackingLogistics(item){
          this.$router.push({
            name:'MyPackage',
            query:{
                id:item.id
            }
          })
      },

      handleSizeChange(val) {
      },
      handleCurrentChange(val) {
        this.$emit('pagingS',val);
      },
      getData(){
          var date = new Date();
          var seperator1 = "-";
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var strDate = date.getDate();
          if (month >= 1 && month <= 9) {
              month = "0" + month;
          }
          if (strDate >= 0 && strDate <= 9) {
              strDate = "0" + strDate;
          }
          var currentdate = year + seperator1 + month + seperator1 + strDate;
          return currentdate;
      }
    },
    created(){
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../../css/tabData.less";
</style>



// WEBPACK FOOTER //
// src/pages/personalPage/orderCenter/TabData.vue